import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"

import { SignUpWidget } from "QuorumGrassroots/widgets/SignUp/components/index"

import { signUpProps } from "QuorumGrassroots/widgets/SignUp/selectors"

export default withNamespaces()(connect(signUpProps, null)(SignUpWidget))
